import Modal from "@stadium/ui/src/components/ModalNew";
import {
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalHeader,
  ModalFooter,
  CloseButton,
} from "@stadium/ui/src/components/ModalNew/utils";
import { InternalButton } from "@components/shared/buttons";

import styles from "./purge-main.module.scss";

const SaveDummyShopPrompt = ({ closeModal }) => {
  return (
    <Modal closeModal={closeModal} mobileBottomDrawer={true} className={styles.exitModal}>
      <ModalDialog className={styles.modalDialog}>
        <ModalContent className={styles.modalContent}>
          <ModalHeader className={styles.modalHeader}>
            <div>
              <h3 className={styles.title}>Save your shop to view product details</h3>
            </div>
            <CloseButton onClick={closeModal} className={styles.closeIcon} />
          </ModalHeader>

          <ModalBody className={styles.modalBody}>
            <p>
              You'll be able to enable/disable products, set product filters, and more after you
              save your shop.
            </p>
          </ModalBody>

          <ModalFooter className={styles.modalFooter}>
            <InternalButton onClick={closeModal} styleType="primary" className={styles.btnMain}>
              Got It
            </InternalButton>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};

export default SaveDummyShopPrompt;
